import * as Yup from "yup";

export const Schema = Yup.object().shape({
    file: Yup.string().required("فیلد فایل الزامی می باشد"),
});
